var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.isMobile())?_c('div',[_c('video',{ref:"video",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/ARK_ GenesisP2.mp4","type":"video/mp4"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }